var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['loader', { 'position-fixed': _vm.centered }]},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"right-side"},[_c('div',{staticClass:"bar"})]),_vm._v(" "),_c('div',{staticClass:"left-side"},[_c('div',{staticClass:"bar"})])])
}]
render._withStripped = true
export { render, staticRenderFns }